import CoreBase from '../../../services/engines/CoreBase';
import gatewayService from '../../../services/GatewayService';
import responseHelper from '../../../services/ResponseHelper';
import formConfigCache from './FormConfigCache';

const _name = 'FormConfigFetcher';
const TOPIC = 'Jerny.FormBuilderConfigs';
const PAGE_SIZE = 50;

class FormConfigFetcher extends CoreBase {
    /**
     * Fetches all entries for the FormBuilderConfigs topic.
     * @returns {object[]|null}
     */
    fetch = async () => {
        try {
            const resp = await gatewayService.getUserEntries(TOPIC, 1, PAGE_SIZE);
            if (responseHelper.check(resp, '', `${_name}.fetch`) < 0) {
                this.logError('name', `code: ${resp?.status}`);
                return [];
            }

            let items = resp.data.items ?? [];

            items = items.filter((x) => x.stateId !== 999);

            formConfigCache.setCache(items);
        } catch (error) {
            this.logError('fetch', error.message);
            return [];
        }
    };
}

const formConfigFetcher = new FormConfigFetcher();
export default formConfigFetcher;
